

const NEW_MESSAGE_ALERT = 'NEW_MESSAGE_ALERT';


const SELECTED_CHAT_ID = 'SELECTED_CHAT_ID'; 

export {
    NEW_MESSAGE_ALERT,
    SELECTED_CHAT_ID,
}